import React from "react";
const GeneralSettingsContext = React.createContext({});
export { GeneralSettingsContext };
